export default "__VITE_ASSET__Dps3bQDA__"